import { Box } from '@mui/material';
import { SearchInput } from '@ui/components';

type TranscriptionSearchProps = {
  query: string;
  onQueryChange: (value: string) => void;
  /** Autofocus when the field becomes visible. */
  autoFocus?: boolean;
};

/**
 * Transcript search field shown below the panel header when search is enabled.
 */
export function TranscriptionSearch({
  query,
  onQueryChange,
  autoFocus = false,
}: TranscriptionSearchProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, flexShrink: 0 }}>
      <SearchInput value={query} onSearch={onQueryChange} fullWidth autoFocus={autoFocus} />
    </Box>
  );
}
